const LOGIN_MESSAGES = {
  ONBOARDING_SUCCESS: 'Organisation created successfully',
  ONBOARDING_FAILURE: 'Oops something went wrong',
  NAME_LABEL: 'Company Name *',
  PHONE_LABEL: 'Phone Number *',
  EMAIL_LABEL: 'Email Address *',
  DESCRIPTION_LABEL: 'Description',
  COMPANY_TYPE_LABEL: 'Company Type',
  ADDRESS_LINE_1_LABEL: 'Address Line 1',
  ADDRESS_LINE_2_LABEL: 'City',
  NAME_PLACEHOLDER: 'Company Name',
  PHONE_PLACEHOLDER: 'Phone Number',
  EMAIL_PLACEHOLDER: 'Email Address',
  COMPANY_TYPE_PLACEHOLDER: 'Select Company Type',
  SUBMIT_BUTTON_LABEL_SUBMITTING: 'Submitting...',
  SUBMIT_BUTTON_LABEL: 'Submit'
};
export default LOGIN_MESSAGES;